import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import genderData from '../../../data/genderOptions.json';
import languageData from '../../../data/languageOptions.json';
import cityData from '../../../data/cityOptions.json';
import raceData from '../../../data/raceEthnicityOptions.json';
import maritalData from '../../../data/maritalStatusOptions.json';
import educationData from '../../../data/educationLevelOptions.json';
import positionData from '../../../data/occupationOptions.json';
import { uploadSingleFile } from '../../../helpers/uploadHelper';
import * as url from '../../../helpers/urlHelper';
import {API_BASE_URL, API_FILE_UPLOAD_SINGLE, API_GENERIC_PATIENT_UPDATE} from "../../../helpers/urlHelper";


const PatientSave = ({ show, handleClose, isEdit, patientData, onPatientSaved  }) => {
    const [formData, setFormData] = useState({
        image: null,
        name: '',
        surname: '',
        email: '',
        phonePrefix: '',
        phone: '',
        password: "",
        zipcode: "",
        gender: '',
        dob: "",
        languages: [],
        city: '',
        emergencycontact: '',
        emergencycontactname: '',
        emergencycontactrelation: "",
        insuranceCompany: "",
        insurance: false,
        insuranceNumber: '',
        race: '',
        maritalStatus: '',
        education: '',
        position: '',
        height: '',
        weight: '',
        isSmoker: "",
        isAlcoholAddict: "",
        isDrugAddict: "",
        address: '',
        about: '',
        summary: '',
        role: 'patient',

    });

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (isEdit && patientData) {
            setFormData({
                ...formData,
                ...patientData,
                image: null,
                role: patientData.role || 'patient',
            });
        } else {
            setFormData({
                image: null,
                name: '',
                surname: '',
                email: '',
                phonePrefix: '',
                phone: '',
                password: "",
                zipcode: "",
                gender: '',
                dob: null,
                languages: [],
                city: '',
                emergencycontact: '',
                emergencycontactname: '',
                emergencycontactrelation: "",
                insuranceCompany: "",
                insurance: false,
                insuranceNumber: '',
                race: '',
                maritalStatus: '',
                education: '',
                position: '',
                height: '',
                weight: '',
                isSmoker: "",
                isAlcoholAddict: "",
                isDrugAddict: "",
                address: '',
                about: '',
                summary: '',
                role: 'patient',
            });
        }
    }, [patientData, isEdit]);

    const handleTextInput = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleProfilePicture = async (e) => {
        const { files } = e.target;
        if (files[0]) {
            try {
                const fileData = await uploadSingleFile(files[0]);

                console.log("Respuesta del servidor:", fileData);

                if (fileData && fileData._id) {

                    setFormData(prev => ({
                        ...prev,
                        profilePicture: files[0],
                        image: fileData._id,
                        imageUrl: `${API_BASE_URL}${fileData.path}`
                    }));
                }
            } catch (error) {
                console.error('Error uploading profile picture:', error);
            }
        }
    };


    const handleSelectChange = (selectedOption, field) => {
        setFormData((prev) => ({
            ...prev,
            [field]: selectedOption ? selectedOption.value : '',
        }));
    };

    const handleMultiSelectChange = (selectedOptions, field) => {
        const values = selectedOptions ? selectedOptions.map((option) => option.value) : [];
        setFormData((prev) => ({
            ...prev,
            [field]: values,
        }));
    };

    const getCurrentSelectValue = (field, options) => {
        return options.find((option) => option.value === formData[field]) || null;
    };

    const getCurrentMultiSelectValue = (field, options) => {
        return options.filter((option) => formData[field].includes(option.value));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const dataToSend = {
            ...formData,
            phone: `${formData.phonePrefix} ${formData.phone}`,
        };
        try {
            setLoading(true);

            const apiUrl = isEdit
                ? `${url.API_BASE_URL}${API_GENERIC_PATIENT_UPDATE.replace(':id', formData._id)}`
                : `${url.API_BASE_URL}${url.API_PATIENT_CREATE}`;

            const response = await fetch(apiUrl, {
                method: isEdit ? 'PUT' : 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(dataToSend),
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const result = await response.json();
            console.log('Success:', result);
            handleClose();

            if (result && result._id) {
                console.log('Paciente creado/actualizado con éxito, ID:', result._id);

                if (onPatientSaved) {
                    onPatientSaved();
                }
                setFormData({
                    image: null,
                    name: '',
                    surname: '',
                    email: '',
                    phonePrefix: '',
                    phone: '',
                    password: "",
                    zipcode: "",
                    gender: '',
                    dob: null,
                    languages: [],
                    city: '',
                    emergencycontact: '',
                    emergencycontactname: '',
                    emergencycontactrelation: "",
                    insuranceCompany: "",
                    insurance: false,
                    insuranceNumber: '',
                    race: '',
                    maritalStatus: '',
                    education: '',
                    position: '',
                    height: '',
                    weight: '',
                    isSmoker: false,
                    isAlcoholAddict: false,
                    isDrugAddict: false,
                    address: '',
                    about: '',
                    summary: '',
                    role: 'patient',
                });
            } else {
                console.error('No se ha devuelto un ID de paciente.');
            }

            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.error('Error:', error);
        }
    };

    return (
        <div className={`offcanvas offcanvas-end ${show ? 'show' : ''}`} tabIndex="-1" id="patientSaveOffcanvas" style={{width: '50%' }}>
            <div className="offcanvas-header">
                <h5 className="offcanvas-title">
                    {isEdit ? 'Edit Patient' : 'Add New Patient'}
                </h5>
                <button type="button" className="btn-close" onClick={handleClose}></button>
            </div>
            <div className="offcanvas-body">
                <form onSubmit={handleSubmit}>
                    <div className="container">
                        <div className="row mt-3 mb-2">
                            <input
                                type="file"
                                className="form-control mb-3"
                                accept="image/*"
                                onChange={handleProfilePicture}
                            />

                            <div
                                style={{
                                    width: '100px',
                                    height: '100px',
                                    borderRadius: '5px',
                                    backgroundColor: '#ffffffff',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    overflow: 'hidden',
                                    position: 'relative',
                                }}
                            >
                                {loading && (
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                )}

                                {!loading && formData.profilePicture && (
                                    <img
                                        src={URL.createObjectURL(formData.profilePicture)}
                                        alt="Preview"
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'cover',
                                        }}
                                        onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.style.display = 'none';
                                        }}
                                    />
                                )}

                                {!loading && !formData.profilePicture && (
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="48"
                                        height="48"
                                        fill="currentColor"
                                        viewBox="0 0 16 16"
                                        style={{ color: '#666' }}
                                    >
                                        <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
                                        <path fillRule="evenodd" d="M14 14s-1-1.5-6-1.5S2 14 2 14s1-4 6-4 6 4 6 4z" />
                                    </svg>
                                )}
                            </div>


                            <div className="col-md-9">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label className="mb-3"> Name</label>
                                        <input type="text" className="form-control mb-3" name="name" placeholder="Name" value={formData.name} onChange={handleTextInput} required />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="mb-3"> Surname</label>
                                        <input type="text" className="form-control mb-3" name="surname" placeholder="Surname" value={formData.surname} onChange={handleTextInput} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <label className="mb-3">Phone</label>
                                        <div className="input-group mb-3">
                                            <select
                                                className="form-select"
                                                name="phonePrefix"
                                                value={formData.phonePrefix}
                                                onChange={handleTextInput}
                                                style={{ maxWidth: "100px" }}
                                            >
                                                <option value="+34">🇪🇸 +34</option>
                                                <option value="+1">🇺🇸 +1</option>
                                                <option value="+44">🇬🇧 +44</option>
                                                <option value="+33">🇫🇷 +33</option>
                                                <option value="+49">🇩🇪 +49</option>
                                                <option value="+39">🇮🇹 +39</option>
                                                <option value="+52">🇲🇽 +52</option>
                                                <option value="+57">🇨🇴 +57</option>
                                            </select>
                                            <input
                                                type="tel"
                                                className="form-control"
                                                name="phone"
                                                placeholder="Phone number"
                                                value={formData.phone}
                                                onChange={handleTextInput}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <label className="mb-3"> email</label>
                                        <input type="email" className="form-control mb-3" name="email" placeholder="Email" value={formData.email} onChange={handleTextInput} required />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr />
                        <div className="row mb-2">
                            <div className="col-md-3">
                                <label className="mb-3"> gender</label>

                                <Select options={genderData.genderOptions} value={getCurrentSelectValue('gender', genderData.genderOptions)} onChange={(option) => handleSelectChange(option, 'gender')} className="mb-3" placeholder="Gender" />
                            </div>
                            <div className="col-md-3">
                                <label className="mb-3"> dob</label>

                                <input type="date" className="form-control mb-3" name="dob" value={formData.dob} onChange={handleTextInput} />
                            </div>

                            <div className="col-md-3">
                                <label className="mb-3"> languages</label>
                                <Select
                                    options={languageData.languageOptions}
                                    value={getCurrentMultiSelectValue('languages', languageData.languageOptions)}
                                    onChange={(options) => handleMultiSelectChange(options, 'languages')}
                                    isMulti
                                    className="mb-3"
                                    placeholder="Languages"
                                />
                            </div>
                            <div className="col-md-3">
                                <label className="mb-3"> City</label>

                                <Select options={cityData.cityOptions} value={getCurrentSelectValue('city', cityData.cityOptions)} onChange={(option) => handleSelectChange(option, 'city')} className="mb-3" placeholder="City" />
                            </div>
                        </div>
                        <hr />
                        <div className="row mb-2">
                            <div className="col-md-4">
                                <label className="mb-3"> Emergency contact</label>

                                <input type="text" className="form-control mb-3" name="emergencycontact" placeholder="Emergency Contact" value={formData.emergencycontact} onChange={handleTextInput} />
                            </div>
                            <div className="col-md-4">
                                <label className="mb-3"> Emergency name</label>

                                <input type="text" className="form-control mb-3" name="emergencycontactname" placeholder="Emergency Contact Name" value={formData.emergencycontactname} onChange={handleTextInput} />
                            </div>
                            <div className="col-md-4">
                                <label className="mb-3"> relation </label>

                                <input type="text" className="form-control mb-3" name="emergencycontactrelation" placeholder="Relation" value={formData.emergencycontactrelation} onChange={handleTextInput} />
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-md-6">
                                <label className="mb-3"> Insurance Company</label>

                                <input type="text" className="form-control mb-3" name="insuranceCompany" placeholder="Insurance Company" value={formData.insuranceCompany} onChange={handleTextInput} />
                            </div>
                            <div className="col-md-6">
                                <label className="mb-3"> Insurance Number</label>

                                <input type="text" className="form-control mb-3" name="insuranceNumber" placeholder="Insurance Number" value={formData.insuranceNumber} onChange={handleTextInput} />
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <div className="col-md-4">
                                <label className="mb-3"> Race</label>
                                <Select options={raceData.raceEthnicityOptions} value={getCurrentSelectValue('race', raceData.raceEthnicityOptions)} onChange={(option) => handleSelectChange(option, 'race')} className="mb-3" placeholder="Race" />
                            </div>
                            <div className="col-md-4">
                                <label className="mb-3"> Marial Status</label>

                                <Select options={maritalData.maritalStatusOptions} value={getCurrentSelectValue('maritalStatus', maritalData.maritalStatusOptions)} onChange={(option) => handleSelectChange(option, 'maritalStatus')} className="mb-3" placeholder="Marital Status" />
                            </div>
                            <div className="col-md-4">
                                <label className="mb-3"> Education Level</label>

                                <Select options={educationData.educationLevelOptions} value={getCurrentSelectValue('education', educationData.educationLevelOptions)} onChange={(option) => handleSelectChange(option, 'education')} className="mb-3" placeholder="Education" />
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <div className="col-md-4">
                                <label className="mb-3"> Position</label>

                                <Select options={positionData.occupationOptions} value={getCurrentSelectValue('position', positionData.occupationOptions)} onChange={(option) => handleSelectChange(option, 'position')} className="mb-3" placeholder="Position" />
                            </div>
                            <div className="col-md-4">
                                <label className="mb-3"> Height</label>

                                <input type="number" className="form-control mb-3" name="height" placeholder="Height (cm)" value={formData.height} onChange={handleTextInput} />
                            </div>
                            <div className="col-md-4">
                                <label className="mb-3"> weight</label>
                                <input type="number" className="form-control mb-3" name="weight" placeholder="Weight (kg)" value={formData.weight} onChange={handleTextInput} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4">
                                <div className="form-check">
                                    <input type="checkbox" className="form-check-input" name="isSmoker" checked={formData.isSmoker} onChange={(e) => setFormData({ ...formData, isSmoker: e.target.checked })} />
                                    <label className="form-check-label">Is Smoker</label>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="form-check">
                                    <input type="checkbox" className="form-check-input" name="isAlcoholAddict" checked={formData.isAlcoholAddict} onChange={(e) => setFormData({ ...formData, isAlcoholAddict: e.target.checked })} />
                                    <label className="form-check-label">Is Alcohol Addict</label>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="form-check">
                                    <input type="checkbox" className="form-check-input" name="isDrugAddict" checked={formData.isDrugAddict} onChange={(e) => setFormData({ ...formData, isDrugAddict: e.target.checked })} />
                                    <label className="form-check-label">Is Drug Addict</label>
                                </div>
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <div className="col-md-12">
                                <label className="mb-3"> address</label>
                                <textarea className="form-control mb-3" name="address" placeholder="address" value={formData.address} onChange={handleTextInput}></textarea>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <label className="mb-3"> about</label>
                                <textarea className="form-control mb-3" name="about" placeholder="About" value={formData.about} onChange={handleTextInput}></textarea>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <label className="mb-3"> Summary</label>
                                <textarea className="form-control mb-3" name="summary"  value={formData.summary} onChange={handleTextInput}></textarea>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <button type="submit" className="btn btn-primary w-100" disabled={loading}>
                                    {loading ? 'Saving...' : (isEdit ? 'Update Patient' : 'Add Patient')}
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default PatientSave;